import React from "react";
import { Container, Typography } from "@mui/material";

export default function Games() {
  return (
    <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
      <Typography variant="h4" gutterBottom>
        Games Placeholder
      </Typography>
    </Container>
  );
}
